export default "{\n    \"impersonateOwner\": \"Impersonate owner\"\n}\n"